/* LIVIBEL: sīktēla pieskāriens pārslēdz galveno galerijas attēlu.
   Tēmas Swiper thumbs saite mobilajā to nedara (slideToClickedSlide
   izpildlaikā ir false), tāpēc šis delegātais klausītājs to nodrošina
   neatkarīgi no Swiper iekšējās konfigurācijas.
   Ielādēts no sections/main-product.liquid (blakus livibel-pdp-gallery.css);
   pēc tēmas atjauninājuma ielādes rinda jāpievieno no jauna. */
(function () {
  function initThumbClicks() {
    document.querySelectorAll('gallery-section.wt-product__gallery').forEach(function (gs) {
      if (gs.dataset.livibelThumbsWired) return;
      var galleryEl = gs.querySelector('[data-gallery]');
      var thumbs = gs.querySelector('[data-thumbs]');
      if (!galleryEl || !thumbs) return;
      gs.dataset.livibelThumbsWired = 'true';
      thumbs.addEventListener('click', function (e) {
        var slide = e.target.closest('.swiper-slide');
        if (!slide || !thumbs.contains(slide)) return;
        var index = Array.prototype.indexOf.call(slide.parentElement.children, slide);
        var sw = galleryEl.swiper;
        if (index < 0 || !sw) return;
        /* Loop režīmā Swiper pievieno slaidu dublikātus — jālieto slideToLoop
           ar reālo indeksu, citādi trāpām dublikātā. */
        if (sw.params.loop && sw.slideToLoop) sw.slideToLoop(index);
        else sw.slideTo(index);
      });

      /* SARGS: galerijā transitionend reizēm nepienāk (pāreju kaut kas
         atceļ), un Swiper "animating" karogs paliek iestrēdzis — loop režīmā
         loopPreventsSlide tad bloķē VISAS nākamās pārslēgšanas. Pēc katras
         pārejas sākuma karogu piespiedu kārtā attīrām, kad pārejai jau
         vajadzēja beigties. */
      function armAnimatingWatchdog() {
        var sw = galleryEl.swiper;
        if (!sw || sw.__lvbWatchArmed) return;
        sw.__lvbWatchArmed = true;
        sw.on('slideChangeTransitionStart', function () {
          clearTimeout(sw.__lvbWatch);
          sw.__lvbWatch = setTimeout(function () {
            if (sw.animating) sw.animating = false;
          }, (sw.params.speed || 300) + 150);
        });
      }
      armAnimatingWatchdog();

      /* Klikšķis uz paša attēla arī pārslēdz attēlus: zona no navigācijas
         pogas līdz attēla ārējai malai katrā pusē (nav jātrāpa tieši pogā);
         viss pārējais (centra reģions) ir klusā zona. Zoom ir izslēgts, tāpēc
         attēla klikšķis ir brīvs. Pēc vilkšanas žesta Swiper uzstāda
         allowClick=false — tad nepārslēdzam (tas bija swipe, ne klikšķis). */
      galleryEl.addEventListener('click', function (e) {
        /* Tikai datorā — mobilajā navigācija ir swipe (bultiņas tur paslēptas). */
        if (window.matchMedia('(max-width: 899px)').matches) return;
        var sw = galleryEl.swiper;
        if (!sw) return;
        armAnimatingWatchdog();
        if (sw.allowClick === false) return;
        if (e.target.closest('.wt-slider__nav-btn, .swiper-pagination, .wt-slider__scrollbar')) return;
        if (!e.target.closest('.swiper-slide')) return;
        var r = galleryEl.getBoundingClientRect();
        var x = e.clientX - r.left;
        /* Sānu zona: pogas josla + rezerve — vismaz 110px vai 18% no platuma. */
        var zone = Math.max(110, r.width * 0.18);
        if (sw.animating) sw.animating = false;
        if (x < zone) sw.slidePrev();
        else if (x > r.width - zone) sw.slideNext();
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThumbClicks);
  } else {
    initThumbClicks();
  }
  document.addEventListener('shopify:section:load', initThumbClicks);
  /* Cilpu (loop) apstrādā pats Swiper — galerijas konfigurācijā ir "loop": true.
     Manuāls bultiņu aplinkus šeit NEDRĪKST būt: cilpas režīmā DOM sākas ar
     pēdējā attēla dublikātu, un slideTo(0) rādītu pēdējo attēlu (lēkāšana). */
})();
